import { black, pdfBadgeBg, pdfBadgeFg } from '@/theme/colors'
import { fontDisplay } from '@/theme/fonts'
import { breakpoints, radii } from '@/theme/tokens'
import styled from 'styled-components'
import Thumbnail from './Thumbnail'
import { horizontalRailMobile } from './TripOverview.styles'

/**
 * Horizontal row of three file thumbnails (design `.bento-thumb-grid` on
 * files). Content-sized and top-aligned: the tile can be stretched by tall
 * grid neighbours (the row-spanning accommodations tile), and thumbnails must
 * never balloon to fill that height — extra space stays below.
 */
export const FileThumbRow = styled.div`
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	align-content: start;
	gap: 14px 12px;

	/* Phone: the thumbnail grid becomes the shared horizontal rail of ~116px
	   cells (6px bottom breathing room per the handoff m-files-rail). */
	@media (max-width: ${breakpoints.phone}px) {
		${horizontalRailMobile(6)}
	}
`

export const FileThumbCell = styled.div`
	display: flex;
	flex-direction: column;
	gap: 7px;
	min-width: 0;

	@media (max-width: ${breakpoints.phone}px) {
		flex: 0 0 116px;
		width: 116px;
	}
`

export const FileThumb = styled(Thumbnail)`
	width: 100%;
	height: 96px;
`

/**
 * PDF cell: the files-page badge (file icon + "PDF" label) in the app-wide
 * PDF red, same box metrics as `FileThumb` so mixed rows line up.
 */
export const PdfThumb = styled.span`
	width: 100%;
	height: 96px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 5px;
	background: ${pdfBadgeBg};
	color: ${pdfBadgeFg};
	border-radius: ${radii.inner};
	flex-shrink: 0;
`

export const PdfThumbLabel = styled.span`
	font-family: ${fontDisplay};
	font-weight: 700;
	font-size: 10.5px;
	letter-spacing: 0.06em;
	text-transform: uppercase;
`

export const FileThumbName = styled.div`
	font-family: ${fontDisplay};
	font-weight: 700;
	font-size: 12.5px;
	color: ${black};
	line-height: 1.3;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
`
